import { useSeoMeta } from '@unhead/react';
import { Palette } from 'lucide-react';
import { CraftProfileForm } from '@/components/CraftProfileForm';
import {
  SKATE_ARTIST_KIND, ARTIST_SERVICE_LABELS, ARTIST_MEDIUM_LABELS, ARTIST_TOOL_LABELS,
} from '@/lib/types';

export default function BecomeArtistPage() {
  useSeoMeta({
    title: 'Become a Designer / Artist - SkateSpots',
    description: 'List your skate design & art — board graphics, logos, posters, merch and more.',
  });

  return (
    <CraftProfileForm
      config={{
        kind: SKATE_ARTIST_KIND,
        selfTag: 'skateartist',
        identifier: 'artist-profile',
        heading: 'Designer / Artist',
        tagline: 'Board graphics, logos, posters, merch — put your art on the scene',
        noun: 'artist',
        accentText: 'text-fuchsia-400',
        accentBg: 'bg-fuchsia-600',
        accentChip: 'bg-fuchsia-600 text-white border-fuchsia-600',
        accentChipHover: 'hover:border-fuchsia-500/60 hover:text-fuchsia-400',
        icon: Palette,
        rateLabel: 'Rate',
        portfolioLabel: 'Portfolio / Shop link',
        skillSections: [
          { title: 'What You Make', entries: Object.entries(ARTIST_SERVICE_LABELS), required: true },
          { title: 'Medium', entries: Object.entries(ARTIST_MEDIUM_LABELS) },
          { title: 'Software & Tools', entries: Object.entries(ARTIST_TOOL_LABELS) },
        ],
      }}
    />
  );
}
